import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { PostRequest } from "./http/BaseRequest";
import { RecordsResponse } from "./http/responses/BaseResponse";
import ServerErrorCodes from "./http/ServerErrorCodes";

/*
export const deleteMiner = (
  id: string // uuid miner
): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/admin/miner/delete", {
    id,
  });
};
*/
export class DeleteMinerRequest extends PostRequest {
  constructor(id : string, tabUnknown?: boolean) {
    const path = tabUnknown ? "/admin/miner/delete_unknown" : "/admin/miner/delete"
    super(path, { id });
  }
}

export interface DeleteMinerError {
  id: string;
  miner_id: string;
  state: MINER_STATUSES_E;
  err_code: ServerErrorCodes;
}

export interface DeleteMinerResponse extends RecordsResponse<DeleteMinerError> {}

export class DeleteMinerRequest2 extends PostRequest {
  constructor(...ids : string[]) {
    super("/admin/miner/delete", { id: ids.join(",") });
  }
}